import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'form-field-integer',
  templateUrl: 'form-field-integer.component.html',
  styleUrls: ['form-field-integer.component.scss']
})
export class FormFieldIntegerComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {
  }



}
